<template>
  <el-container class="index-con">
    <el-aside :class="showclass" style="overflow: inherit; height: inherit" width="initial">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con content" :class="{ 'content-collapse': collapse }">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <keep-alive>
          <router-view :key="$route.name" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view :key="$route.name" v-if="!$route.meta.keepAlive" />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from "../components/navcon.vue";
import leftnav from "../components/leftnav.vue";
import { mapState } from "vuex";
export default {
  name: "index",
  data() {
    return {
      showclass: "asideshow",
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav,
  },
  computed: {
    ...mapState({
      collapse: (state) => state.sidebar.opened,
    }),
  },



  methods: {},
  created() { },
};
</script>
<style>
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.aside {
  width: 64px !important;
  height: 100%;
  margin: 0px;
}

.asideshow {
  width: 200px;
  height: 100%;
  background: #354052;
  margin: 0px;
}

.index-header,
.index-main {
  height: 30px !important;
  padding: 0px;
  background: #f5f5f5;
}

.content {
  /* background: none repeat scroll 0 0 #f0f0f0; */
  background-color: #fff;
  position: absolute;
  left: 200px;
  right: 0;
  top: 0;
  bottom: 0;
  width: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*overflow-y: scroll;*/
  overflow: auto;
  -webkit-transition: left 0.3s ease-in-out;
  transition: left 0.3s ease-in-out;
}

.is-home {
  padding: 0;
  bottom: -5px;
  left: 200px;
}

.content-collapse {
  left: 65px;
}

.content-collapse.is-home {
  left: 64px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue